import { Text } from '../../../cdl/Text/Text';
import { Box } from '../../../common/ui/Box';

interface PriceListsEmptyStateProps {
    title: string;
}

export const PriceListsEmptyState = ({ title }: PriceListsEmptyStateProps) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="84px"
            borderRadius={8}
            border="1.5px dashed"
            borderColor="border.muted"
        >
            <Text variant="small" color="foreground.muted">
                {title}
            </Text>
        </Box>
    );
};
